import { GeneralModel } from "./general.model";
import { Country } from "./country.model";


export class Province extends GeneralModel {
    countryId: number;
    country: Country;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/province.model.ts